import { FONT_BASE } from 'game/constants/AppFonts';

// Expected fields:
// dossier_logo
// dossier_from
// dossier_subtitle
// dossier_summary
// dossier_body

export class DisplayDocumentDossier extends Phaser.GameObjects.Container {
  constructor(scene, data) {
    super(scene);
    scene.add.existing(this);

    this.x = 0;
    this.y = 250;

    this._data = data;
    this.addDocumentDetails();
  }

  addDocumentDetails() {
    const {
      dossier_logo = '',
      dossier_from = '',
      dossier_subtitle = '',
      dossier_summary = '',
      dossier_body = '',
    } = this._data;

    const dossierLogoOffset = dossier_logo !== 'none' ? 117 : 20;

    // email header
    this.dossier_from = this.scene.add
      .text(dossierLogoOffset, 21, dossier_from, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    this.dossier_subtitle = this.scene.add
      .text(
        dossierLogoOffset,
        this.dossier_from.y + this.dossier_from.height + 5,
        dossier_subtitle,
        {
          fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
          fontSize: '22px',
          color: '#000000',
        }
      )
      .setOrigin(0);

    this.topLine = this.scene.add
      .rectangle(dossierLogoOffset, 80, dossier_logo !== 'none' ? 780 : 878, 1, 0x000000)
      .setOrigin(0);

    this.dossier_summary = this.scene.add
      .text(dossierLogoOffset, 95, dossier_summary, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '22px',
        color: '#000000',
        fontStyle: 'italic',
      })
      .setOrigin(0);

    this.bottomLine = this.scene.add.rectangle(20, 130, 878, 1, 0x000000).setOrigin(0);

    this.body = this.scene.add
      .text(20, 147, dossier_body, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '22px',
        color: '#000000',
        wordWrap: { width: 874 },
      })
      .setOrigin(0);

    this.add([
      this.dossier_from,
      this.dossier_subtitle,
      this.dossier_summary,
      this.topLine,
      this.bottomLine,
      this.body,
    ]);

    if (dossier_logo !== 'none') {
      this.dossier_logo = this.scene.add.sprite(20, 12, 'dossierlogos', dossier_logo).setOrigin(0);
      this.add([this.dossier_logo]);
    }
  }

  shutdown() {
    this.destroy();
  }
}
